import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n'; // CRITICAL #2: Initialize i18n BEFORE App renders
import App from './App';
import './styles/index.css';

// Silence console.log everywhere - keep error and warn for real issues
console.log = () => {};


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
